export default __webpack_public_path__ + "static/media/shop-categories-img03.6888eac4.jpg";